// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";

import { formatHumanReadableDate } from "src/utils";

import Common from "./Common";

import type { Message } from "src/types";

type Props = {
  message: Message,
};

const Duedate = ({ message }: Props) => {
  const { data } = message;
  const { new: newDate, old: oldDate } = data;
  if (newDate && oldDate)
    return (
      <Common {...message}>
        {" "}
        {i18n.t(k.UPDATED_THE_DUE_DATE_TO)}{" "}
        <strong>{formatHumanReadableDate(newDate.toDate())}</strong>
      </Common>
    );

  if (newDate)
    return (
      <Common {...message}>
        {" "}
        {i18n.t(k.SET_THE_DUE_DATE_TO)}{" "}
        <strong data-cy="new-due-date-notification">
          {formatHumanReadableDate(newDate.toDate())}
        </strong>
      </Common>
    );

  return <Common {...message}> {i18n.t(k.REMOVED_THE_DUE_DATE)}</Common>;
};

export default Duedate;
